import { Link } from 'react-router-dom'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import locations from '../../../../../../utils/globals/locations'
import { useCustomerParsedLinkMemo } from '../../../../../../utils/hooks/customer/useCustomerTypesDict'

interface ITHeaderTextProps {
    label: string
    value: string
    className?: string
}

const ITHeaderText: React.FC<ITHeaderTextProps> = ({ label, value, className }) => {
    return (
        <div className={'flex flex-col it_header_text_component gap-y-2 ' + (className || '')}>
            <span className='light12 twin_elipsis text-gray-51'>{label}</span>
            <div className='flex items-center h-33 py-2 px-8 border border-gray-D6 bg-gray-EE'>
                <span className='regular14 text-ellipsis whitespace-nowrap h-19 overflow-hidden' >{value}</span>
            </div>
        </div>
    )
}

export const ITHeaderTextWrap: React.FC<ITHeaderTextProps> = ({ label, value, className }) => {
    return (
        <div className={'flex flex-col  ' + (className || '')}>
            <span className='light12 text-gray-51 mb-4'>{label}</span>
            <span className='regular14' >{value}</span>
        </div>
    )
}

interface ITHeaderTextCustomerProps {
    label: string
    headerData: TwinDictionary
    className?: string
    showCustomerProjectName?: boolean
}

export const ITHeaderTextCustomer: React.FC<ITHeaderTextCustomerProps> = ({ label, headerData, className, showCustomerProjectName = true }) => {
    const { parsedLinkMemo } = useCustomerParsedLinkMemo({ id: headerData?.Customer?.id, customer_type: headerData?.Customer?.customer_type })
    let projectName = ''
    if (headerData?.CustomerProject && showCustomerProjectName) {
        projectName = ' - ' + headerData.CustomerProject?.name
    }
    return (
        <div className={'flex flex-col ' + (className || '')}>
            <span className='light12 text-gray-51 mb-4'>{label}</span>
            <Link className='cursor-pointer hover:text-green-43' to={parsedLinkMemo}>
                <span className='regular14 h-19 twin_elipsis block max-w-full' >{(headerData?.Customer?.fiscal_name || headerData?.Customer?.name) + projectName}</span>
            </Link>
        </div>
    )
}
interface ITHeaderTextSupplierProps {
    label: string
    headerData: TwinDictionary
    className?: string
}

export const ITHeaderTextSupplier: React.FC<ITHeaderTextSupplierProps> = ({ label, headerData, className }) => {
    return (
        <div className={'flex flex-col ' + (className || '')}>
            <span className='light12 text-gray-51 mb-4'>{label}</span>
            <Link className='cursor-pointer hover:text-green-43 w-fit' to={locations.suppliers + '/' + headerData?.SupplierId +'/main'}>
                <span className='regular14 text-ellipsis whitespace-nowrap h-19 overflow-hidden' >{headerData?.Supplier?.name}</span>
            </Link>
        </div>
    )
}
interface ITHeaderTextOrderProps {
    label: string
    OrderId: number
    full_asssigned_number: string
    className?: string
    orderUrl: string
    readOnly?: boolean
}

export const ITHeaderTextOrder: React.FC<ITHeaderTextOrderProps> = ({ label, orderUrl, className, full_asssigned_number, OrderId, readOnly }) => {
    let renderThis = (
        <Link className='cursor-pointer hover:text-green-43 w-fit' to={orderUrl + '/' + OrderId}>
            <span className='regular14 text-ellipsis whitespace-nowrap h-19 overflow-hidden' >{full_asssigned_number}</span>
        </Link>
    )
    if (readOnly) {
        renderThis = <span className='regular14 text-ellipsis whitespace-nowrap h-19 overflow-hidden' >{full_asssigned_number}</span>
    }
    return (
        <div className={'flex flex-col ' + (className || '')}>
            <span className='light12 text-gray-51 mb-4'>{label}</span>
            {renderThis}
        </div>
    )
}

export default ITHeaderText